export const DEFAULT_SECTIONS = {
  navigation: {
    key: "navigation",
    button_label: "Tickets",
    button_url: "#events",
    image: "",
    metadata: {
      links: [
        { label: "Events", href: "#events" },
        { label: "Fighters", href: "#roster" },
        { label: "Ethos", href: "#manifesto" },
        { label: "Join", href: "#join" },
      ],
    },
  },
  hero: {
    key: "hero",
    eyebrow: "Boxing Promotion / Est. Goa",
    title: "Susegado",
    title_accent: "Strike",
    body: "Ruthless elegance in the ring. Where composure meets violence — a fight promotion built on patience, precision, and the perfect strike.",
    button_label: "See the Fight Card",
    button_url: "#events",
    image: "https://images.unsplash.com/photo-1552072092-7f9b8d63efcb",
    metadata: { image_alt: "Fighter entering the ring", scroll_label: "Scroll" },
  },
  marquee: {
    key: "marquee",
    metadata: {
      words: ["Susegado Strike", "Ruthless Elegance", "Patience", "Precision", "The Perfect Strike"],
    },
  },
  events: {
    key: "events",
    eyebrow: "Fight Calendar",
    title: "Upcoming",
    title_accent: "Events",
    metadata: { section_index: "01", loading_text: "Loading fight card…", tickets_label: "Tickets", max_items: 2 },
  },
  roster: {
    key: "roster",
    eyebrow: "The Stable",
    title: "Our",
    title_accent: "Fighters",
    body: "A roster forged across continents. Each name below carries the weight of the Susegado Strike banner into battle.",
    metadata: { section_index: "02", loading_text: "Loading fighters…", max_items: 2 },
  },
  manifesto: {
    key: "manifesto",
    eyebrow: "The Ethos",
    title: "Ruthless",
    title_accent: "Elegance",
    metadata: {
      section_index: "03",
      chapters: [
        { number: "01", title: "Susegado", body: "A Goan philosophy — the art of unhurried calm. In the ring, panic loses. We teach our fighters to carry stillness into the storm." },
        { number: "02", title: "The Strike", body: "Elegance is patience made visible. We do not throw a thousand punches. We wait for the one that ends the conversation." },
        { number: "03", title: "The Banner", body: "More than a promotion — a standard of craft. Every card is choreographed for spectacle, every fighter treated as an artist of violence." },
      ],
      stats: [
        { value: "07", label: "Events / Year" },
        { value: "40+", label: "Roster Fighters" },
        { value: "12", label: "Countries" },
        { value: "100%", label: "Sold-Out Nights" },
      ],
    },
  },
  join: {
    key: "join",
    eyebrow: "Ringside",
    title: "Never miss a",
    title_accent: "bell",
    body: "Fight announcements, ticket drops, and behind-the-ropes access. Join the inner circle.",
    button_label: "Subscribe",
    metadata: {
      section_index: "04",
      email_placeholder: "your@email.com",
      interests: ["Tickets", "Sponsorship", "Fighter Tryout", "Press / Media"],
      contact_title: "Get in",
      contact_title_accent: "touch",
      contact_body: "Tickets, sponsorship, tryouts or press — tell us what you need.",
      contact_button_label: "Send Message",
      name_placeholder: "Name",
      contact_email_placeholder: "Email",
      message_placeholder: "Your message",
    },
  },
  sponsors: {
    key: "sponsors",
    eyebrow: "In The Corner",
    title: "Our",
    title_accent: "Sponsors",
    metadata: { section_index: "05" },
  },
  team: {
    key: "team",
    eyebrow: "Behind The Banner",
    title: "The",
    title_accent: "Team",
    body: "The minds orchestrating every fight night — the founders who built the banner and the manager who runs the show.",
    metadata: { section_index: "06" },
  },
  footer: {
    key: "footer",
    title: "Susegado",
    title_accent: "Strike",
    body: "Susegado Strike Promotions. All rights reserved.",
    metadata: {
      tagline: "Ruthless Elegance · Goa · Worldwide",
      socials: [
        { label: "Instagram", url: "https://instagram.com" },
        { label: "YouTube", url: "https://youtube.com" },
        { label: "X", url: "https://x.com" },
      ],
    },
  },
};

export const DEFAULT_SPONSORS = [
  "GOLDEN GLOVE",
  "APEX NUTRITION",
  "IRONCLAD",
  "VELOCITY SPORTS",
  "NOVA FIGHT GEAR",
  "TITAN WATCHES",
  "COASTAL RUM CO.",
  "PRIMAL WEAR",
].map((name, index) => ({ id: `default-sponsor-${index}`, name, logo: "", website_url: "" }));

export const DEFAULT_TEAM_MEMBERS = [
  { id: "founder-1", name: "Founder Name", role: "Co-Founder", image: "https://images.unsplash.com/photo-1618517048289-4646902edaf5" },
  { id: "founder-2", name: "Founder Name", role: "Co-Founder", image: "https://images.unsplash.com/photo-1607702713064-0143212236ae" },
  { id: "founder-3", name: "Founder Name", role: "Co-Founder", image: "https://images.unsplash.com/photo-1552072092-7f9b8d63efcb" },
  { id: "manager-1", name: "Manager Name", role: "General Manager", image: "https://images.unsplash.com/photo-1509563268479-0f004cf3f58b" },
];

export const resolveSection = (sections, key, contentLoaded) => {
  const fallback = DEFAULT_SECTIONS[key];
  const incoming = sections?.[key];

  if (!incoming) return contentLoaded ? null : fallback;

  return {
    ...fallback,
    ...incoming,
    metadata: {
      ...(fallback?.metadata || {}),
      ...(incoming?.metadata || {}),
    },
  };
};
